// Copyright (c) StrangeBee 2024

import { DescribeOutput, QuerySelector } from 'thehive-sdk';

interface GetSelectorParams {
    taskId: string;
}

export const computeGetSelector = ({ taskId }: GetSelectorParams): QuerySelector => ({
    head: [{ name: 'getTask', idOrName: taskId }],
    extraData: ['actionRequired', 'actionRequiredMap', 'case', 'logCount'],
    name: `get-task-details-${taskId}`,
});

interface ListSelectorParams {
    caseId: string;
    describeData?: DescribeOutput;
}

export const computeListSelector = ({ caseId }: ListSelectorParams): QuerySelector => ({
    head: [{ name: 'getCase', idOrName: caseId }, { name: 'tasks' }],
    extraData: ['actionRequired', 'shareCount', 'logCount', 'case'],
    name: `get-case-tasks-${caseId}`,
    sort: ['+order'],
});
